import { match } from '../utilities/ResolutionHandler';
import BaseComponent from '../abstracts/BaseComponent';

export default class DropdownComponent extends BaseComponent {
  get Messages() {
    return {
      [this.CUSTOM_MESSAGES.DROPDOWN_EVENTS.hide]: this.close
    };
  }

  get SELECTORS() {
    return {
      panel: '.js-dropdown-panel',
      trigger: '.js-dropdown-trigger',
      inputInside: '.floatl__label'
    };
  }

  get PARENT() {
    return this.$el.closest('.js-dropdown-container');
  }

  get IS_OPEN() {
    return this.$el.parentElement.classList.contains(this.CLASSES.open);
  }

  constructor(element) {
    super(element);

    this.timeout = null;

    this.bindEvents();
  }

  get CLASSES() {
    return {
      open: 'open',
      animate: 'animate',
      active: 'active',
      dot: 'dot'
    };
  }

  /**
   *
   * @param {String} content - Panel content
   * @param {Array} [parentClasses = []] - Parent element classes
   * @param {Array} [panelClasses ? []] - Panel classes
   */
  open(content, parentClasses = [], panelClasses = []) {
    try {
      const parent = this.$el.parentElement;
      const panel = parent.querySelector(this.SELECTORS.panel);

      parent.classList.add(this.CLASSES.open);

      this.timeout = setTimeout(
        () => {
          if (content) {
            panel.innerHTML = content;
          }

          if (parentClasses) {
            this.parentClasses = parentClasses;
            parent.classList.add(...parentClasses);
          }

          if (panelClasses) {
            this.parentClasses = parentClasses;
            panel.classList.add(...panelClasses);
          }

          this.$el.classList.add(this.CLASSES.active);
          parent.classList.add(this.CLASSES.animate);
        }, 100
      );
    } catch (e) {
      console.error(e);
    }
  }

  close() {
    try {
      const parent = this.$el.parentElement;
      const panel = parent.querySelector(this.SELECTORS.panel);
      parent.classList.remove(this.CLASSES.animate);

      if (this.parentClasses) parent.classList.remove(...this.parentClasses);
      if (this.panelClasses) panel.classList.remove(...this.panelClasses);

      this.timeout = setTimeout(
        () => {
          parent.classList.remove(this.CLASSES.open);
          this.$el.classList.remove(this.CLASSES.active);
        }, 100
      );
    } catch (e) {
      console.error(e);
    }
  }

  bindHover() {
    var anyFocus = false;
    if (match(null, 'medium')) {
      this.$on('mouseenter.dropdown', (e) => {
        e.preventDefault();
        clearTimeout(this.timeout);
        clearTimeout(this.closeTimeout);
        clearTimeout(this.openTimeout);
        this.openTimeout = setTimeout(() => {
          this.open();
        }, 100);
      }, this.$el.parentElement);

      this.$on('mouseleave.dropdown', (e) => {
        const parent = this.$el.parentElement;
        const inputInside = parent.querySelectorAll(this.SELECTORS.inputInside);
        [...inputInside].forEach((el) => {
          if (this.checkIfFocus(el)) {
            anyFocus = true;
          }
        });

        if (!anyFocus) {
          e.preventDefault();
          clearTimeout(this.timeout);
          clearTimeout(this.openTimeout);
          this.closeTimeout = setTimeout(() => {
            this.close();
          }, 100);
        } else {
          anyFocus = false;
        }
      }, this.$el.parentElement);
    }
  }

  bindClick() {
    this.$on('click.dropdown', (e) => {
      if (e) {
        e.preventDefault();
      }

      clearTimeout(this.timeout);
      const isOpen = this.$el.parentElement.classList.contains(this.CLASSES.open);
      if (isOpen) {
        this.close();
      } else {
        this.open();
      }
    }, this.$el);
  }

  bindEvents() {
    if (this.$options.handle === 'hover') {
      this.bindHover();
    }
    if (this.$options.handle === 'click') {
      this.bindClick();
    }
    if (this.$options.handle === 'all' || !this.$options.handle) {
      this.bindClick();
      this.bindHover();
    }
  }

  checkIfFocus(el) {
    return (el.form === (document.activeElement.form || null)) && (document.activeElement.localName === 'input');
  }
}
